import React, { Component } from "react";
import "react-native-gesture-handler";
import { ThemeProvider } from "@shopify/restyle";
import { View, AppState, LogBox, Linking, Platform, Text } from "react-native";
import { Provider, batch } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Loading } from "./components/common";
import { store, persistor } from "@microdoing/shared/services/store";

import messaging from "@react-native-firebase/messaging";

import opoFontFix from "./utils/opoFontFix";
import SafeAreaApp from "./SafeAreaApp";
import NotifService from "../NotifService";

import theme from "./Theme/Theme";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import redirectNavigation from "./utils/redirectionNotification";
import navigatorHelper from "../../shared/services/navigation/navigatorHelper";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import SplashScreen from "react-native-splash-screen";

console.ignoredYellowBox = ["Remote debugger"];
LogBox.ignoreLogs([
  "Required dispatch_sync to load constants for RNDeviceInfo. This may lead to deadlocks",
  "Module RCTImageLoader requires",
  "Unrecognized WebSocket connection option(s) `agent`, `perMessageDeflate`, `pfx`, `key`, `passphrase`, `cert`, `ca`, `ciphers`, `rejectUnauthorized`. Did you mean to put these under `headers`?",
  "Require cycle:",
]);

// This is used in order to see requests on the Chrome DevTools
global.XMLHttpRequest = global.originalXMLHttpRequest
  ? global.originalXMLHttpRequest
  : global.XMLHttpRequest;
global.FormData = global.originalFormData
  ? global.originalFormData
  : global.FormData;
global.Blob = global.originalBlob ? global.originalBlob : global.Blob;
global.FileReader = global.originalFileReader
  ? global.originalFileReader
  : global.FileReader;

const codePushSettings = {
  // checkFrequency: codePush.CheckFrequency.MANUAL,
};

// fix bug font not found in One plus, Opo and some android devices
opoFontFix();

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: "",
    };

    this.notif = new NotifService(
      this.onRegister.bind(this),
      this.onNotif.bind(this),
    );
  }

  componentWillUnmount() {
    if (Platform.OS !== "web") {
      this.messageListener();
    }
  }

  componentDidMount = async () => {
    if (Platform.OS !== "web") {
      this.messageListener = messaging().onMessage(async remoteMessage => {});

      messaging()
        .getInitialNotification()
        .then((notificationOpen: NotificationOpen) => {
          if (notificationOpen) {
            // App was opened by a notification
            // Get the action triggered by the notification being opened
            const action = notificationOpen.action;
            // Get information about the notification that was opened
            const notification: Notification = notificationOpen.notification;
            if (notification?.data?.type === "message") {
              // navigate to message
              // navigatorHelper.navigate("Message");
            }
          }
        });

      messaging().onNotificationOpenedApp(remoteMessage => {
        // this.onNotif(remoteMessage?.notification);
        const notification = remoteMessage.notification;
        if (notification?.data?.type === "message") {
          // navigate to message
          // navigatorHelper.navigate("Message");
        }
      });
    }

    if (!isWeb) {
      SplashScreen.hide();
    }
  };

  onRegister(token) {}

  onNotif(notification) {
    if (store?.getState()?.nav?.appState !== "active") {
      const { navigationRoute, navigationParams } = redirectNavigation({
        event: notification?.data?.event || notification?.data?.receivers,
        type: notification?.data?.type,
        _id: notification?.data?._id || notification?.data?.conversationId,
        userId: notification?.data?.userId,
        dispatch: store.dispatch,
      });
      if (navigationRoute) {
        navigatorHelper.navigate(navigationRoute, navigationParams);
      }
    }
  }

  render() {
    return (
      <GestureHandlerRootView
        style={
          Platform.OS !== "web"
            ? { flex: 1 }
            : {
                height: "100vh",
                maxWidth: "820",
                width: "100%",
                position: "relative",
                display: "flex",
                flex: 1,
              }
        }
      >
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <PersistGate
              loading={
                <View style={styles.loadingView}>
                  <Loading size={45} />
                </View>
              }
              persistor={persistor}
            >
              <SafeAreaProvider>
                <SafeAreaApp />
              </SafeAreaProvider>
            </PersistGate>
          </Provider>
        </ThemeProvider>
      </GestureHandlerRootView>
    );
  }
}

const styles = {
  loadingView: {
    flex: 1,
    zIndex: 1000,
    position: "absolute",
    height: "100%",
    width: "100%",
    backgroundColor: theme.colors["brand.500"],
    alignItems: "center",
    justifyContent: "center",
  },
};

export default App;
